import { z } from 'zod';

import {
  type TestAssetStatus,
  TestAssetStatus as TAS,
  type TestAssetStatusFilter,
} from './-query/type';

const testAssetStatusValues = Object.values(TAS) as [
  TestAssetStatus,
  ...TestAssetStatus[],
];

export const TestAssetStatusFilterSchema = z.enum([
  'ALL',
  ...testAssetStatusValues,
]);

/**
 * テストアセット一覧のステータスタブ並び順:
 *   アクティブ / メンテナンス中 / レガシー / すべて
 */
export const TEST_ASSET_STATUS_TABS = [
  TAS.ACTIVE,
  TAS.IN_MAINTENANCE,
  TAS.LEGACY,
  'ALL',
] as const satisfies readonly TestAssetStatusFilter[];

export function buildTestAssetTabChangeSearch(tab: string) {
  const result = TestAssetStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : ('ALL' as const),
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const,
  };
}
